<template>
  <v-sheet
    class="thumbnail-container cursor-pointer flex-shrink-0"
    :width="small ? 60 : 80"
    :height="small ? 60 : 80"
  >
    <v-sheet
      v-ripple
      class="rounded-lg overflow-hidden"
      width="100%"
      height="100%"
      @click="$emit('show')"
    >
      <ImageMedia
        class="w-100 h-100"
        :key="image.id"
        :size="IMAGE_SIZES.CARD"
        :src="image"
      />
    </v-sheet>

    <v-icon
      v-if="!readOnly"
      size="22"
      color="blue-grey darken-2"
      class="thumbnail-delete-button rounded-circle"
      @click="$emit('remove')"
    >
      mdi-close-circle
    </v-icon>
  </v-sheet>
</template>

<script>
import { IMAGE_SIZES } from 'rever-media-sdk'

import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'

export default {
  name: 'MediaContainerThumbnailImage',

  components: {
    ImageMedia,
  },

  props: {
    image: {
      type: Object,
      required: true,
    },

    readOnly: Boolean,

    small: Boolean,
  },

  data() {
    return {
      IMAGE_SIZES,
    }
  },
}
</script>

<style lang="scss" scoped>
.thumbnail-container {
  position: relative;
}

.thumbnail-delete-button {
  width: 24px !important;
  height: 24px !important;
  position: absolute;
  top: -6px;
  right: -6px;

  i {
    font-size: 16px !important;
  }
  background-color: white;
}
</style>
